/* ============================================================
   VETRO GLASS — interactions (vanilla, no dependencies)
   ============================================================ */
(function () {
  'use strict';
  /* mark JS active — reveal animations only hide content when this class is present,
     so if this script ever fails to load, all content stays fully visible */
  document.documentElement.classList.add('v-js');
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---- theme toggle (default light, remembered) ---- */
  var SUN = '<circle cx="12" cy="12" r="4.2"/><path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5 5l1.5 1.5M17.5 17.5 19 19M19 5l-1.5 1.5M6.5 17.5 5 19"/>';
  var MOON = '<path d="M21 12.8A8.5 8.5 0 1 1 11.2 3a6.5 6.5 0 0 0 9.8 9.8Z"/>';
  function applyTheme(t) {
    var icon = document.querySelector('.v-toggle svg');
    var label = document.querySelector('.v-toggle .v-toggle-label');
    if (t === 'light') {
      document.documentElement.setAttribute('data-theme', 'light');
      if (icon) icon.innerHTML = SUN;
      if (label) label.textContent = 'Light';
    } else {
      document.documentElement.removeAttribute('data-theme');
      if (icon) icon.innerHTML = MOON;
      if (label) label.textContent = 'Dark';
    }
  }
  function initTheme() {
    var saved = null;
    try { saved = localStorage.getItem('vetro-theme'); } catch (e) {}
    applyTheme(saved || 'dark');
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.v-toggle');
      if (!t) return;
      var cur = document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
      var next = cur === 'light' ? 'dark' : 'light';
      applyTheme(next);
      try { localStorage.setItem('vetro-theme', next); } catch (e) {}
    });
  }

  /* ---- header: solid on interior pages, frosted on scroll ---- */
  function initHeader() {
    var header = document.querySelector('.v-header');
    if (!header) return;
    var main = document.getElementById('MainContent');
    var first = main && main.querySelector('.shopify-section');
    var overHero = !!(first && first.querySelector('.v-hero, .v-pagehero'));
    header.classList.toggle('is-solid', !overHero);
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- mobile drawer ---- */
  function initDrawer() {
    var drawer = document.querySelector('.v-drawer');
    if (!drawer) return;
    function close() { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
    document.addEventListener('click', function (e) {
      if (e.target.closest('.v-menu-btn')) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      else if (e.target.closest('.v-drawer-close') || e.target.closest('.v-drawer a')) { close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- reveal on scroll, counters, capability bars ---- */
  function fmt(v, dec) { v = parseFloat(v); return dec ? v.toFixed(dec) : Math.round(v).toLocaleString(); }
  function animateCount(el) {
    var to = parseFloat(el.dataset.to), dec = el.dataset.dec, start = null, dur = 1600;
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(to * e, dec);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initReveal() {
    var els = document.querySelectorAll('.v-reveal,.v-reveal-img,.v-bar-fill,.v-count');
    if (rm || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-in');
        if (el.classList.contains('v-bar-fill')) el.style.right = (100 - el.dataset.w) + '%';
        if (el.classList.contains('v-count')) el.textContent = fmt(el.dataset.to, el.dataset.dec);
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        if (e.target.classList.contains('v-bar-fill')) e.target.style.right = (100 - e.target.dataset.w) + '%';
        if (e.target.classList.contains('v-count')) animateCount(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- portfolio / gallery filter ---- */
  function initFilters() {
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('.v-chip');
      if (!chip) return;
      var scope = chip.closest('.v-section, .vetro') || document;
      scope.querySelectorAll('.v-chip').forEach(function (x) { x.classList.remove('is-active'); });
      chip.classList.add('is-active');
      var f = chip.dataset.f;
      scope.querySelectorAll('.v-port').forEach(function (p) {
        p.classList.toggle('is-hide', f !== 'all' && p.dataset.cat !== f);
      });
    });
  }

  /* ---- FAQ accordion ---- */
  function initFaq() {
    document.addEventListener('click', function (e) {
      var q = e.target.closest('.v-faq-q');
      if (!q) return;
      q.parentElement.classList.toggle('is-open');
    });
  }

  /* ---- gallery lightbox ---- */
  function initLightbox() {
    var lb = document.querySelector('.v-lightbox');
    if (!lb) return;
    var img = lb.querySelector('img');
    var items = [], idx = 0;
    function collect() { items = Array.prototype.slice.call(document.querySelectorAll('.v-gitem:not(.is-hide)')); }
    function show(i) {
      collect();
      if (!items.length) return;
      idx = (i + items.length) % items.length;
      var el = items[idx];
      img.src = el.getAttribute('data-full') || el.querySelector('img').src;
      img.alt = el.querySelector('img').alt || '';
      lb.classList.add('is-open');
    }
    document.addEventListener('click', function (e) {
      var g = e.target.closest('.v-gitem');
      if (g) { collect(); show(items.indexOf(g)); return; }
      if (e.target.closest('.v-lb-close') || e.target === lb) { lb.classList.remove('is-open'); return; }
      if (e.target.closest('.v-lb-next')) { show(idx + 1); return; }
      if (e.target.closest('.v-lb-prev')) { show(idx - 1); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') lb.classList.remove('is-open');
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'ArrowLeft') show(idx - 1);
    });
  }

  /* ---- product page: gallery, quantity, variant switching ---- */
  function initProduct() {
    var pdp = document.querySelector('.v-pdp');
    if (!pdp) return;

    var mainImg = document.getElementById('vpdp-main-img');
    pdp.querySelectorAll('.v-pdp-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        pdp.querySelectorAll('.v-pdp-thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (mainImg) mainImg.src = t.getAttribute('data-full');
      });
    });

    var qty = document.getElementById('vpdp-qty');
    pdp.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10);
        qty.value = Math.max(1, v);
      });
    });

    var vEl = document.getElementById('vpdp-variants');
    if (!vEl) return;
    var variants;
    try { variants = JSON.parse(vEl.textContent); } catch (e) { return; }
    var idInput = document.getElementById('vpdp-variant-id');
    var priceEl = document.getElementById('vpdp-price');
    var addBtn = document.getElementById('vpdp-add');
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'GBP';
    function money(cents) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt }).format(cents / 100); }
      catch (e) { return '£' + (cents / 100).toFixed(2); }
    }
    function update() {
      var chosen = [];
      pdp.querySelectorAll('.v-opt').forEach(function (o) {
        var sel = o.querySelector('input:checked');
        chosen.push(sel ? sel.value : null);
      });
      var match = variants.filter(function (v) {
        return (v.options || []).every(function (ov, i) { return ov === chosen[i]; });
      })[0];
      if (!match) return;
      idInput.value = match.id;
      var html = money(match.price);
      if (match.compare_at_price && match.compare_at_price > match.price) html += '<s>' + money(match.compare_at_price) + '</s>';
      if (priceEl) priceEl.innerHTML = html;
      if (addBtn) {
        addBtn.disabled = !match.available;
        var lbl = addBtn.querySelector('span');
        if (lbl) lbl.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
    }
    pdp.querySelectorAll('.v-opt input').forEach(function (i) { i.addEventListener('change', update); });
    update();
  }

  initTheme();
  ready(function () {
    initHeader();
    initDrawer();
    initReveal();
    initFilters();
    initFaq();
    initLightbox();
    initProduct();
  });

  /* re-init reveals when sections are re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', function () {
    initHeader();
    initReveal();
  });
})();
